<div class="p-6 bg-white shadow rounded-md cursor-pointer hover:bg-earth-try transition-all duration-500 ease-in-out" [routerLink]="['/infobox']" [queryParams]="{boxid: infobox.id}" routerLinkActive="router-link-active">
  <img [src]="infobox.afbeelding" />
  <h2 class="text-lg font-semibold text-black/70 transition-all duration-500">{{infobox.titel}}</h2>
  <h3 class="text-slate-400 mt-3 mb-2">{{infobox.subtitel}}</h3>
</div>
